import request from '@/utils/request'
let LinkApi = {
    /*获取数据列表*/
    getList(data) {
        return request._post('/shop/link.link/index', data);
    },
    /*获取数据列表*/
    getPageList(data) {
        return request._post('/shop/link.link/getPageList', data);
    },
    /*获取营销数据列表*/
    getMarketingList(data) {
        return request._post('/shop/link.link/getMarketingList', data);
    },
}
export default LinkApi;



// WEBPACK FOOTER //
// ./src/api/link.js